/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Summary_Integration_Past_1Inputs */



/**
* | output |
* | --- |
* | "used your integrations" |
*
* @param {Chat_Summary_Integration_Past_1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_summary_integration_past_1 = /** @type {((inputs?: Chat_Summary_Integration_Past_1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Summary_Integration_Past_1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("deine Integrationen genutzt")
	return /** @type {LocalizedString} */ ("used your integrations")
});